import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListingListComponent } from './product-listing-list/product-listing-list.component';
import { ProductListingFormComponent } from './product-listing-form/product-listing-form.component';
import { HasRoleGuard } from '../core/has-role.guard';

const routes: Routes = [
  {
    path: '',
    component: ProductListingListComponent,
    canActivate: [HasRoleGuard],
  },
  {
    path: ':mode',
    component: ProductListingFormComponent
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductListingRoutingModule { }
